import { Injectable, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class TranslationStateService {
  private translate = inject(TranslateService);

  readonly translationsLoaded = signal(false);

  constructor() {
    // Use a small delay to allow the translation service to initialize
    setTimeout(() => {
      this.initializeTranslations();
    }, 100);
  }

  private initializeTranslations() {
    const currentLang = this.translate.currentLang || this.translate.getDefaultLang();
    const currentTranslations = this.translate.translations[currentLang];
    const hasTranslations = currentTranslations && Object.keys(currentTranslations).length > 0;

    if (hasTranslations) {
      this.translationsLoaded.set(true);
    } else {
      this.translate.onTranslationChange.subscribe(() => {
        this.translationsLoaded.set(true);
      });

      this.translate.onLangChange.subscribe(event => {
        const translations = this.translate.translations[event.lang];
        if (translations && Object.keys(translations).length > 0) {
          this.translationsLoaded.set(true);
        }
      });
    }
  }
}
